import styled from 'styled-components'

interface ITeamNameProps {
  color: string;
}

export const Container = styled.div<any>`
  width: 136px;
  height: 136px;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background: ${(props) => 'linear-gradient(180deg, ' + props.bg + ' 0%, rgba(196, 196, 196, 0) 100%)' || 'linear-gradient(180deg, #7B61FF 0%, rgba(196, 196, 196, 0) 100%)'};
  & > span {
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #232323;
  }
`

export const Content = styled.div`
  width: 105px;
  height: 105px;

  background: #fff;
  border-radius: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Point = styled.h6`
  color: #232323;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
`

export const TeamName = styled.div<ITeamNameProps>`
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 116px;
  min-height: 33px;

  background: ${({ color }) => color};
  border-radius: 27px;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;

  display: flex;
  align-items: center;
  justify-content: center;
`
